<template>
<div>


   <vs-row class="mt-2" vs-type="flex" >
             <div class="md:w-1/2 w-full p-1">
            <vs-input
                placeholder="Search"
                class="w-full"
                v-model="search"
                @keyup="searchFun"
                style="width: 100%"
              />
          </div>
        <vs-col vs-xs="12" vs-sm="6" vs-lg="8" vs-justify="flex-end" vs-align="center">
           <vs-button color="danger" v-if="isRowSelected" @click="notificationDeletePopup">Bulk Delete</vs-button>
        </vs-col>
      </vs-row>
  
    <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="limitedTableList"
        rowSelection="multiple"
        colResizeDefault="true"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        @cell-clicked="cellSingleClicked"
        @row-selected = "CellvalueSelectDeselect"
        :enableRtl="$vs.rtl"
        @grid-ready="onGridReady"
        @sortChanged="sortFun"
        >
        
    </ag-grid-vue>
     
            <ItemsPerTableDropdown
              tableName="notification"
              @change="(pageLimit) => pageLimitSet = pageLimit"
            />
          <pagination style="float:right;" :meta="meta" @page-change="handlePageChange" />
      

<!-- @rowClicked="rowClicked" @cell-value-changed="onCellValueChanged"
        @row-selected="CellvalueSelectDeselect"-->

    <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
        <vs-col vs-xs="12" vs-sm="6" vs-lg="4" vs-type="flex" vs-justify="start" vs-align="center">
          <!-- page limit select view -->
          <!-- <span style="font-size:12px">
            Show
            <select
              v-model="pageLimitSet"
              style="background: #fff !important;height:40px;width:70px;font-size:12px"
              class="form-control vs-select--input vs-select--input-con"
            >
              <option
                v-for="(option,index) of pageLimitOPtion"
                :key="index"
                :value="option.value"
                :label="option.value"
                class="vs-select--options"
              >{{option.value}}</option>
            </select>entry
          </span>
          <span
            style="font-size:12px"
          >| showing {{meta.current_page}} to {{pageLimitSet}} of {{ tableData.length}}</span> -->
        </vs-col>
       
      </vs-row>

    <vs-popup  title="Please confirm" :active.sync="deletepopupflag">
        <vs-row>
          <span>Are you sure to delete notifications?</span>
          
        </vs-row>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button @click="handleBulkDelete" color="red" type="filled" class="mr-2 vs-con-loading__container">Accept</vs-button>
          <vs-button @click="deletepopupflag=!deletepopupflag" type="border">Cancel</vs-button>
        </vs-row>
      </vs-popup>

    <div class="full-cstm-sidebar mt-107" :class="{'open': notiSidebar}">
    <!-- <vs-sidebar position-right parent="#parentx-demo-2" :hidden-background="true" default-index="1"  color="primary" class="sidebarx cstm-sidebarx" spacer v-model="notiSidebar"> -->
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>Notification Details</h4>
            <feather-icon icon="XIcon" class="cursor-pointer" @click="handlcreateSidebar" />
        </div>
        <vs-divider class="mb-0" />
        <div class="p-6 pt-2 sidebar-scrollable-form" >
           <vs-row vs-justify="space-between">
             <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="2">
             <h6>Time: </h6>
             </vs-col>
             <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="9.8">
               <p>{{selectedRowData.created_time}}</p>
               </vs-col>
               </vs-row> 
               <vs-row vs-justify="space-between">
             <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="2">
             <h6>From: </h6>
             </vs-col>
             <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="9.8">
               <p>{{selectedRowData.first_name + ' ' + selectedRowData.last_name}}</p>
               </vs-col>
               </vs-row> 
               <vs-row>
                  <p class="mt-4">{{selectedRowData.notification_details}}</p>
               </vs-row> 
            
           
        </div>
    </div>
    <div class="bg-overlay"></div>
</div>
</template>
<script>
import cellRendereFullName from '@/views/pages/notification/FullNameNotification.vue'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import deleteCell from './deleteCell'
import Bell from './Bell'
import Pagination from '@/components/common/pagination'
import {mapGetters, mapActions} from 'vuex'
import { notificationList, notificationRead, notificationDelete } from '@/api/notification.js'


export default {
  name: 'notification',
  components: {
    AgGridVue,
    deleteCell,
    Bell,
    Pagination,
    cellRendereFullName
  },
  data () {
    return {
      search:'',
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      searchQuery: '',
      deletepopupflag: false,
      isRowSelected: false,
      selectedRowData: [],
      query_page: {
        page: 1,
        limit: 10
      },
      pageLimitSet: 5,
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      pageLimitOPtion: [
        {
          'name': 2,
          'value': 2
        },
        {
          'name': 5,
          'value': 5
        },
        {
          name: 'All',
          value: 'all'
        }
      ],
      notiSidebar: false,
      gridOptions: {
        accentedSort: true,
        rowClassRules: {
          'unread' (params) { return params.data.read === false },
          'read' (params) { return params.data.read === true }
        }
      },
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
        // autoHeight: true
      },
      components: {
        deleteCell
      },
      tableData: [],
      columnDefs: [
        {
          headerName: '',
          cellRendererFramework: 'Bell',
          field: 'is_read',
          filter: true,
          sortable: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: '#',
          field: 'row_index',
          filter: true,
          resizable: true,
          editable: false,
          sortable: false,
          width: 125
        },
        {
          headerName: 'Details',
          field: 'notification_details',
          filter: true,
          resizable: true,
          editable: false,
          width: 400
        },
        {
          headerName: 'From',
          field: 'first_name',
          filter: true,
          resizable: true,
          editable: false,
          width: 175,
          sortable: false,
          cellRendererFramework:'cellRendereFullName'
        },
        {
          headerName: 'Date and Time',
          field: 'created_at',
          filter: true,
          resizable: true,
          editable: false,
          width: 225
        },
        {
          headerName: 'Action',
          filter: false,
          editable: false,
          resizable: true,
          sortable: false,
          width: 125,
          cellRendererFramework: 'deleteCell'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(
      ['get_notifications_deleted_id']
    ),
    
    limitedTableList () {
    
      return this.tableData
    }
  },

  watch: {
    get_notifications_deleted_id () {
      if (this.get_notifications_deleted_id) {
        const table  = this.tableData
        const dlt_id  = table.findIndex(item => item.notification_id === this.get_notifications_deleted_id)
        table.splice(dlt_id, 1)
        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.tableData = table

        if (this.tableData.length === 0 && !this.meta.next_page_url) {
          this.handlePageChange(this.meta.current_page - 1)
        } else {
          this.handlePageChange(this.meta.current_page)
        }
      }
    },
    pageLimitSet () {
      this.handlePageChange(1)
    }
    
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    const payload = {
      search:this.search
    }
    notificationList(localStorage.getItem('customer_id'), this.pageLimitSet, this.query_page.page, this.sorting_obj, 'notification', payload)
      .then((res) => {
        
        this.tableData = res.data.data.results
        const queryParams = this.$route.query || {}
        this.query_page.page = queryParams.page || 1
        this.query_page.limit = this.pageLimitSet
        this.fetch_list(this.query_page)
      
      })
      .catch((e) => {
        
      })
  },
  methods: {
    ...mapActions(['SET_UNREAD_NOTIFICATION_READ']),
    searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        vm.handlePageChange(1)
      } catch (e) {
        console.log(e)
      }
    }, 1000),
    async sortFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()
        this.sorting_obj.field_type = 'system'
        this.sorting_obj.attribute = sortState[0].colId
        this.sorting_obj.direction = sortState[0].sort
        this.fetch_list()
      } catch (e) {}
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    handlcreateSidebar () {
      this.notiSidebar = false
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    async fetch_list (query) {
      try {
        const payload = {
          search:this.search
        }
        const { data } = await notificationList(localStorage.getItem('customer_id'), this.pageLimitSet, this.query_page.page, this.sorting_obj, 'notification', payload)
    
        const table = data.data.results
        this.meta = data.data.meta
        table.map((row, index) => {
          
          const row_index = index + 1
          
          Object.assign(row, { row_index })
         
        })
        this.tableData = table
        
      
      } catch (e) {
        
      }
    },
    handlePageChange (page) {
      const queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      queryPayload.limit = this.pageLimitSet
      this.query_page.page = page
      /* const pageScroll = document.documentElement.scrollTop
      this.$router.replace({ path: '/pages/notification', query: queryPayload }).then(() => {
        document.documentElement.scrollTop = pageScroll
      }) */
      this.fetch_list(queryPayload)
    },
    cellSingleClicked (params) {
      if (params.column.colId === 'is_read' || params.column.colId === 'row_index' || params.column.colId === 'notification_details'
      || params.column.colId === 'first_name' || params.column.colId === 'created_at') {
        this.notiSidebar = true
        this.selectedRowData = params.data
        
        
        if (params.data.is_read) {
          const payload = {
            customer_id: localStorage.getItem('customer_id'),
            notification: [params.data.notification_id]
          }
          /* this.tableData[0].notification_details = 'yasin'
          
          
           */
          notificationRead(payload)
            .then((res) => {
              if (res) {
                this.tableData[params.data.row_index - 1].is_read = false
                this.gridOptions.api.refreshCells() 
                this.SET_UNREAD_NOTIFICATION_READ('read')


              }
            })
            .catch((e) => {
              
            })
        }
      }
     
    },
    CellvalueSelectDeselect () {
  
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      
      if (selectedNodes) {
        const selecttedNode = this.gridApi.getSelectedNodes()
        const selectedRows = selecttedNode.map(node => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected =  true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },
    getSelectedRows () {
      const selectedData = this.gridApi.getSelectedRows()
      return selectedData
    },
    notificationDeletePopup () {
      this.deletepopupflag = true
    },
    handleBulkDelete () {
      const BulkSelected = this.getSelectedRows()
      const deleting_ids = []
      for (let i = 0; i < BulkSelected.length; i++) {
        
        deleting_ids.push(BulkSelected[i].notification_id)
       
      }
    
      if (deleting_ids.length === 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Selected rows are non-actionable',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } else {
        const payload = {
          customer_id: localStorage.getItem('customer_id'),
          notification: deleting_ids
        }
        
        notificationDelete(payload).then(data => {
          const table = this.tableData
          this.deletepopupflag = false
          this.isRowSelected = false
          for (const delete_id_itr of deleting_ids) {
            for (let i = 0; i < table.length; i++) {
              
              if (delete_id_itr === table[i].notification_id) {
                table.splice(i, 1)
            
              }
            }
          }
          table.map((row, index) => {
            row.row_index = index + 1
          })
          this.tableData =  table

          if (this.tableData.length === 0 && !this.meta.next_page_url) {
            this.handlePageChange(this.meta.current_page - 1)
          } else {
            this.handlePageChange(this.meta.current_page)
          }

          this.$vs.notify({
            title: 'Success',
            text: 'Bulk Deletion Successfull',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          
        }).catch(e => {
          
        })
      }
      
    }
  }
  
}
</script>

<style>
  .unread {
    background-color: #fff5ec;
    font-weight: 500;
  }
  .read {
    background-color: transparent !important;
    font-weight: 500;
  }
  .cstm-sidebarx .sidebar-scrollable-form {
    height: calc(100% - 70px);
    overflow-y: auto;
    overflow-x: hidden;
   }   
   .cstm-sidebarx .vs-sidebar {
       margin-top: 107px;
       max-width: 320px;
   }
</style>

